import React from 'react'

const WelcomePageContainer = (props) => {
    return <div>Hi! I'm mockup design service.</div>
}

export default WelcomePageContainer

